import { render, staticRenderFns } from "./BackendTranslatedEntityPlainTextRenderer.vue?vue&type=template&id=905d34b4&"
import script from "./BackendTranslatedEntityPlainTextRenderer.vue?vue&type=script&lang=js&"
export * from "./BackendTranslatedEntityPlainTextRenderer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports